import dayjs from "dayjs";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportEntregaObraClienteGeralUseCase } from "../../../presentation/useCases/read/get_report_entrega_obra_cliente_geral_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";

/**
 * GetReportEntregaObraClienteGeralUseCase
 */

export class GetReportEntregaObraClienteGeralUseCase implements IGetReportEntregaObraClienteGeralUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(
    requiredMimeType: ReportMimeType | null,
    idEntregaObra: number,
    status?: number[] | null,
    vistorias?: number[] | null,
    clientes?: number[] | null,
    unidades?: number[] | null,
    checklists?: number[] | null,
    localVistorias?: number[] | null,
    dataInspecaoDe?: Date | null,
    dataInspecaoAte?: Date | null,
    idUsuario?: number,

  ): Promise<ReportData> {
    const response = await this.repository.getReportEntregaObraClienteGeral(
      requiredMimeType,
      idEntregaObra,
      status,
      vistorias,
      clientes,
      unidades,
      checklists,
      localVistorias,
      dataInspecaoDe,
      dataInspecaoAte,
      idUsuario

    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `entrega_obra_cliente_monitoramento${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
